import { Label, mergeStyles, Stack } from "@fluentui/react";

import { commaNumber } from "../../NumberField";
import { getSummary } from "../New/Components/utils";
import { FormVariables, Product } from "../slice/newFormReducers";
import { BorderedStack, Item } from "./utils";

type Props = {
  formVariables: FormVariables;
};

const Header = () => (
  <BorderedStack horizontal>
    {columns.map((column) => (
      <Item
        grow={column.grow !== false}
        width={column.width}
        className={headerCellStyles}
      >
        {column.header}
        {column.title && <Label className={labelStyles}>{column.title}</Label>}
      </Item>
    ))}
  </BorderedStack>
);

export const ProductList = (props: Props) => {
  if (!props.formVariables.products) {
    return <></>;
  }

  const products = Object.values(props.formVariables.products).filter(
    (product) => product?.productInfo
  );

  return (
    <div className="form-styles">
      {products.map((product, index) => (
        <div className="page-break" style={{
          marginTop: "-1px",
          backgroundColor: product.isShipped ? "#ffff99" : undefined,
        }}>
          <BorderedStack key={product.uuid}>
            {columns.map((column) => (
              <Item
                key={column.title}
                grow={column.grow !== false}
                width={column.width}
                className={cellStyles}
                style={{
                  textAlign: column.alignRight ? "right" : undefined,
                }}
              >
                {column.transform(product, index) || "-"}
              </Item>
            ))}
          </BorderedStack>
        </div>
      ))}
    </div>
  );
};

export const ProductInfoList = (props: Props) => {
  const summary = getSummary(props.formVariables);
  const bottomInfo =
    summary.discountAmount > 0
      ? [
          { text: "Ürün Tutarı", amount: summary.totalProductCost },
          { text: "İskonto", amount: summary.discountAmount },
          { text: "Genel Toplam", amount: summary.grandTotal },
        ]
      : [{ text: "Genel Toplam", amount: summary.grandTotal }];

  return (
    <Stack tokens={{ childrenGap: -1 }} className="form-styles">
      {bottomInfo.map((info) => (
        <BorderedStack horizontalAlign="end">
          <Item width="30%" className={cellStyles}>
            <Label>
              <b>{info.text}:</b>
            </Label>
          </Item>
          <Item
            width="30%"
            className={cellStyles}
            style={{ textAlign: "right" }}
          >
            <b>{commaNumber(info.amount)} TL</b>
          </Item>
        </BorderedStack>
      ))}
    </Stack>
  );
};

export const ProductListWithHeader = (props: Props) => {
  const { formVariables } = props;
  const hasNonEmptyProduct =
    formVariables.products &&
    !!Object.keys(formVariables.products).find(
      (uuid) => formVariables.products?.[uuid]?.productInfo
    );

  if (hasNonEmptyProduct) {
    return (
      <Stack tokens={{ childrenGap: 5 }} className="form-styles">
        <Header />
        <ProductList {...props} />
      </Stack>
    );
  } else {
    return <></>;
  }
};

const cellStyles = mergeStyles({
  wordWrap: "break-word",
  padding: "0 6px",
  "> *": {
    padding: "0 !important",
  },
});
const headerCellStyles = mergeStyles({
  padding: "0 6px",
});
const labelStyles = mergeStyles({
  padding: "0",
  margin: "0",
});
const columns = [
  {
    width: "24px",
    grow: false,
    header: "#",
    transform: (_: any, index: number) => index + 1,
  },
  {
    width: "40%",
    title: "Açıklama",
    transform: (product: Product) =>
      [
        product.productInfo?.name,
        product.description,
        product.isShipped ? "[Teslim Edildi]" : "",
      ]
        .filter((v) => !!v?.trim())
        .join(" - "),
  },
  {
    width: "5%",
    title: "Adet",
    grow: false,
    // alignRight: true,
    transform: (product: Product) => product.count,
  },
  {
    width: "15%",
    title: "Birim Fiyatı",
    grow: false,
    alignRight: true,
    transform: (product: Product) =>
      product.sellPrice ? commaNumber(product.sellPrice) + " TL" : undefined,
  },
  {
    width: "15%",
    title: "Tutar",
    grow: false,
    alignRight: true,
    transform: (product: Product) =>
      product.sellPrice &&
      product.count &&
      commaNumber(product.sellPrice * product.count) + " TL",
  },
];
